import { api } from "./api";

export interface CategoriaApostila {
  id: string;
  nome: string;
  descricao: string | null;
  ordem: number;
  apostilas?: ApostilaBasica[];
  criado_em: string;
  alterado_em: string;
}

export interface ApostilaBasica {
  id: string;
  titulo: string;
  ordem: number;
  publicado: boolean;
}

export interface CreateCategoriaData {
  nome: string;
  descricao?: string;
  ordem?: number;
}

export interface UpdateCategoriaData {
  nome?: string;
  descricao?: string;
  ordem?: number;
}

class CategoriasApostilasService {
  async list(): Promise<CategoriaApostila[]> {
    const response = await api.get("/apostilas/categorias");
    return response.data;
  }

  async create(data: CreateCategoriaData): Promise<CategoriaApostila> {
    const response = await api.post("/apostilas/categorias", data);
    return response.data;
  }

  async update(id: string, data: UpdateCategoriaData): Promise<CategoriaApostila> {
    const response = await api.put(`/apostilas/categorias/${id}`, data);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/apostilas/categorias/${id}`);
  }

  async reordenar(ordens: Array<{ id: string; ordem: number }>): Promise<void> {
    await api.put("/apostilas/categorias/reordenar", { ordens });
  }
}

export const categoriasApostilasService = new CategoriasApostilasService();
